/* =========================================================================
   HOLY SPIRIT — Integracion Hero / safe-area (Home movil)
   -------------------------------------------------------------------------
   Complemento de hs-home-overscroll.css. En Home movil quita el meta
   theme-color para que iOS Safari NO pinte una franja solida sobre la barra
   de estado: asi la imagen del Hero se ve detras de la hora, WiFi y bateria
   (edge-to-edge real). El Hero ya se extiende dentro de la safe-area por CSS
   (margin-block-start negativo con env(safe-area-inset-top)).

   - Solo Home (este archivo se carga solo en template == index) y solo en
     <990px. En desktop se restaura el theme-color original.
   - El rubber-band ya esta bloqueado por hs-ios-rubberband-fix.js, por lo
     que este theme-color ya no se necesita oscuro arriba.
   - No toca header, mega menu, footer, carrito, PDP ni paginas internas
     (esas conservan su theme-color).
   ========================================================================= */
(function () {
  var mq = window.matchMedia('(max-width: 989.98px)');
  var stored = null; // meta removido, para poder restaurarlo en desktop

  function apply() {
    if (mq.matches) {
      // Home movil: quitar theme-color -> el Hero se ve tras la barra de estado
      var m = document.querySelector('meta[name="theme-color"]');
      if (m) {
        stored = { content: m.getAttribute('content') || '' };
        m.parentNode.removeChild(m);
      }
    } else if (stored) {
      // Desktop: restaurar si no existe ya
      if (!document.querySelector('meta[name="theme-color"]')) {
        var nm = document.createElement('meta');
        nm.setAttribute('name', 'theme-color');
        nm.setAttribute('content', stored.content);
        document.head.appendChild(nm);
      }
      stored = null;
    }
  }

  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();
